/** Imported media sometimes has only the artist name, not an EntityRef id. */
export function artistProfileHref(
  artist: { slug?: string; docId?: string; id?: string; name?: string } | string | null | undefined,
  artistId?: string,
): string | null {
  const ref = typeof artist === 'object' && artist ? artist : undefined;
  const key = [ref?.slug, ref?.docId, ref?.id, artistId]
    .find(value => typeof value === 'string' && value.trim())?.trim();
  if (key) return `/artists/${encodeURIComponent(key)}`;
  const name = typeof artist === 'string' ? artist : ref?.name;
  // Same name fallback as the artist route's legacy import lookup.
  const slug = (name || '').toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
  return slug ? `/artists/${slug}` : null;
}
